import { ComponentType, useEffect, useState, useMemo } from 'react';
import { Switch, Route } from 'react-router-dom';
import { useSelector } from 'react-redux';
import SupplierTabContext from './SupplierTabContext';
import _SuppliersUsers from './SupplierUsers/SuppliersUsers';
import _SuppliersComponent from './SupplierComponent/SuppliersComponent';
import _SuppliersDocuments from './SupplierDocuments/SuppliersDocuments';

const SuppliersUsers = _SuppliersUsers as unknown as ComponentType<unknown>;
const SuppliersComponent = _SuppliersComponent as unknown as ComponentType<unknown>;
const SuppliersDocuments = _SuppliersDocuments as unknown as ComponentType<unknown>;

interface SupplierTabLayoutProps {
  match: { params: { supplierId?: string } };
}

interface SupplierTabLayoutState {
  UserDetails?: { isSupplierLoggedIn?: boolean };
}

/**
 * Route shell for the Partner Management sub-tabs. Owns the tier flag every tab
 * reads and publishes it, with the supplier id, on `SupplierTabContext` for
 * `SupplierTabNav`. Pill positioning now lives inside `CommonTabSwitch`, so no
 * underline measurement is kept here.
 * @param {object} props - Component props.
 * @param {object} props.match - React Router match carrying `supplierId`.
 * @returns {React.ReactElement} The context provider wrapping the tab routes.
 */
function SupplierTabLayout({ match }: SupplierTabLayoutProps) {
  const { supplierId } = match.params;
  const isSupplierLoggedIn = useSelector((state: SupplierTabLayoutState) => state.UserDetails?.isSupplierLoggedIn);
  const [selectedTier, setSelectedTier] = useState('Tier1');

  useEffect(() => {
    const tier = localStorage.getItem('SupplierSelectedTier') || 'Tier1';
    setSelectedTier(tier);
  }, []);

  const isProductionLocationTier = selectedTier !== 'Tier1';

  const contextValue = useMemo(
    () => ({ isSupplierLoggedIn, isProductionLocationTier, supplierId }),
    [isSupplierLoggedIn, isProductionLocationTier, supplierId],
  );

  return (
    <SupplierTabContext.Provider value={contextValue}>
      <Switch>
        <Route exact path="/supplier/:supplierId/users" component={SuppliersUsers} />
        <Route exact path="/supplier/:supplierId/component-suppliers" component={SuppliersComponent} />
        <Route exact path="/supplier/:supplierId/supporting-docs" component={SuppliersDocuments} />
      </Switch>
    </SupplierTabContext.Provider>
  );
}

export default SupplierTabLayout;
